/**
 * Minigame "baleni-s-rychlonozkou" – configurable constants.
 * Item names define the 14 items (order = display order); selection state uses these as ids.
 * Image paths: items/{id}.png and items/{id}-bubble.png in scene folder.
 */
export const ITEM_NAMES: string[] = [
  'satek',
  'provaz',
  'chleba',
  'nuz',
  'nuzky',
  'konvice',
  'kpz',  
  'cutora',
  'telefon',
  'teplaky',
  'bryle',
  'kramle',
  'knizka',
  'mic',
]

/** Number of items the player must select to pass the minigame */
export const ITEMS_NEEDED_TO_PASS = 7
